import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CoreModule } from 'world-archery-lib';
import { WorldRankingBootstrapComponent } from './components/world-ranking-bootstrap/world-ranking-bootstrap.component';
import { WorldRankingFiltersService } from './services/world-ranking-filters.service';
import { WorldRankingRoutingModule } from './world-ranking-routing.module';
import { CommonPageComponentsModule } from '../../common-page-components/common-page-components.module';

@NgModule({
  bootstrap: [WorldRankingBootstrapComponent],
  imports: [CommonModule, WorldRankingRoutingModule, CoreModule, CommonPageComponentsModule],
  declarations: [
    WorldRankingBootstrapComponent,
  ],
  providers: [WorldRankingFiltersService],
})
export class WorldRankingModule { }
